const TABLE_HEADER_INFO = {
    composition: [
        [
            { name: "materialCd", value: "Material Code" },
            { name: "component", value: "Component" },
            { name: "mainAlter", value: "Main/Alter" },
            { name: "concentration", value: "Concentration" },
            { name: "unit", value: "Unit" },
            { name: "reference", value: "Reference", style: {borderRight: "1pt solid #000"} },
        ],
    ],
    in: [
        [
            { name: "paraDesc", value: "Parameter Description", rowSpan: "3" },
            { name: "unit", value: "Unit", rowSpan: "3" },
            { name: "inReceivingSite", value: "Receiving Site", colSpan: "6" },
            { name: "inSendingSite", value: "Sending Site", colSpan: "6" },
            { name: "reference", value: "Reference", rowSpan: "3", style: {borderRight: "1pt solid #000"} },
        ],
        [
            { name: "rcvCritical", value: "Criticality", rowSpan: "2" },
            { name: "rcvSetpoint", value: "Set Point", rowSpan: "2" },
            { name: "rcvTargetRange", value: "Target Range", colSpan: "2" },
            { name: "rcvAcceptableRange", value: "Acceptable Range", colSpan: "2" },
            { name: "sndCritical", value: "Criticality", rowSpan: "2" },
            { name: "inSetpoint", value: "Set Point", rowSpan: "2" },
            { name: "inTargetRange", value: "Target Range", colSpan: "2" },
            { name: "inAcceptableRange", value: "Acceptable Range", colSpan: "2" },
        ],
        [
            { name: "rcvTargetMin", value: "Min" },
            { name: "rcvTargetMax", value: "Max" },
            { name: "rcvAccMin", value: "Min" },
            { name: "rcvAccMan", value: "Max" },
            { name: "sndTargetMin", value: "Min" },
            { name: "sndTargetMax", value: "Max" },
            { name: "sndAccMin", value: "Min" },
            { name: "sndAccMan", value: "Max" },
        ],
    ],
    out: [
        [
            { name: "paraNm", value: "Parameter", rowSpan: "3" },
            { name: "sopNo", value: "SOP No.", rowSpan: "3" },
            { name: "unit", value: "Unit", rowSpan: "3" },
            { name: "outReceivingSite", value: "Receiving Site", colSpan: "6" },
            { name: "outSendingSite", value: "Sending Site", colSpan: "6" },
            { name: "reference", value: "Reference", rowSpan: "3", style: {borderRight: "1pt solid #000"} },
        ],
        [
            { name: "rcvCritical", value: "Criticality", rowSpan: "2" },
            { name: "rcvTargetRange", value: "Target Range", colSpan: "2" },
            { name: "rcvAcceptableRange", value: "Acceptable Range", colSpan: "2" },
            { name: "sndCritical", value: "Criticality", rowSpan: "2" },
            { name: "outTargetRange", value: "Target Range", colSpan: "2" },
            { name: "outAcceptableRange", value: "Acceptable Range", colSpan: "2" },
        ],
        [
            { name: "rcvTargetMin", value: "Min" },
            { name: "rcvTargetMax", value: "Max" },
            { name: "rcvAccMin", value: "Min" },
            { name: "rcvAccMan", value: "Max" },
            { name: "sndTargetMin", value: "Min" },
            { name: "sndTargetMax", value: "Max" },
            { name: "sndAccMin", value: "Min" },
            { name: "sndAccMan", value: "Max" },
        ],
    ],
    qc: [
        [
            { name: "sampleDesc", value: "Sample Description", rowSpan: "3" },
            { name: "paraNm", value: "Parameter", rowSpan: "3" },
            { name: "testMethod", value: "Test Method", rowSpan: "3" },
            { name: "unit", value: "Unit", rowSpan: "3" },
            { name: "qcReceivingSite", value: "Receiving Site", colSpan: "6" },
            { name: "qcSendingSite", value: "Sending Site", colSpan: "6" },
            { name: "options", value: "Options", rowSpan: "3"},
            { name: "reference", value: "Reference", rowSpan: "3", style: {borderRight: "1pt solid #000"} },
        ],
        [
            { name: "rcvCritical", value: "Criticality", rowSpan: "2" },
            { name: "rcvAlertLimit", value: "Alert Limit", colSpan: "2" },
            { name: "rcvActionLimit", value: "Action Limit", colSpan: "2" },
            { name: "rcvAcceptableLimit", value: "Acceptable Limit", colSpan: "2" },
            { name: "sndCritical", value: "Criticality", rowSpan: "2" },
            { name: "qcAlertLimit", value: "Alert Limit", colSpan: "2" },
            { name: "qcActionLimit", value: "Action Limit", colSpan: "2" },
            { name: "qcAcceptableLimit", value: "Acceptable Limit", colSpan: "2" },
        ],
        [
            { name: "rcvAlrMin", value: "Min" },
            { name: "rcvAlrMax", value: "Max" },
            { name: "rcvActMin", value: "Min" },
            { name: "rcvActMax", value: "Max" },
            { name: "rcvAccMin", value: "Min" },
            { name: "rcvAccMax", value: "Max" },
            { name: "sndAlrMin", value: "Min" },
            { name: "sndAlrMax", value: "Max" },
            { name: "sndAct1Min", value: "Min" },
            { name: "sndAct1Max", value: "Max" },
            { name: "sndAccMin", value: "Min" },
            { name: "sndAccMax", value: "Max" },
        ],
    ],
};

const TABLE_BODY_INFO = {
    composition: [
        "materialCd",
        "component",
        "mainAlter",
        "concentration",
        "unit1+unit2",
        "reference",
    ],
    in: [
        "paraDesc",
        "unit",
        "rcvCriticalNm+rcvCritical",
        "rcvSetpoint",
        "rcvTarMinSign+rcvTarMin",
        "rcvTarMaxSign+rcvTarMax",
        "rcvAccMinSign+rcvAccMin",
        "rcvAccMaxSign+rcvAccMax",
        "sndCritical",
        "sndSetpoint",
        "sndTarMinSign+sndTarMin",
        "sndTarMaxSign+sndTarMax",
        "sndAcc1MinSign+sndAcc1Min",
        "sndAcc1MaxSign+sndAcc1Max",
        "reference",
    ],
    out: [
        "paraNm",
        "sopNo",
        "unit",
        "rcvCriticalNm+rcvCritical",
        "rcvSetpoint",
        "rcvTarMinSign+rcvTarMin",
        "rcvTarMaxSign+rcvTarMax",
        "rcvAccMinSign+rcvAccMin",
        "rcvAccMaxSign+rcvAccMax",
        "sndCritical",
        "sndSetpoint",
        "sndTarMinSign+sndTarMin",
        "sndTarMaxSign+sndTarMax",
        "sndAcc1MinSign+sndAcc1Min",
        "sndAcc1MaxSign+sndAcc1Max",
        "reference",
    ],
    qc: [
        "sampleDesc",
        "paraNm",
        "testMethod",
        "unit",
        "rcvCriticalNm+rcvCritical",
        "rcvAlrMinSign+rcvAlrMin",
        "rcvAlrMaxSign+rcvAlrMax",
        "rcvActMinSign+rcvActMin",
        "rcvActMaxSign+rcvActMax",
        "rcvAccMinSign+rcvAccMin",
        "rcvAccMaxSign+rcvAccMax",
        "sndCritical",
        "sndAlrMinSign+sndAlrMin",
        "sndAlrMaxSign+sndAlrMax",
        "sndAct1MinSign+sndAct1Min",
        "sndAct1MaxSign+sndAct1Max",
        "sndAccMinSign+sndAccMin",
        "sndAccMaxSign+sndAccMax",
        "optionNm+optionCd",
        "reference",
    ],
};

const TABLE_BODY_INFO2 = {
    composition: [
        "materialCd",
        "component",
        "mainAlter",
        "concentration",
        "unit1+unit2",
        "reference",
    ],
    in: [
        "paraNm",
        "paraDesc",
        "unit",
        "rcvCriticalNm+rcvCritical",
        "rcvSetpoint",
        "rcvTarMinSign+rcvTarMin",
        "rcvTarMaxSign+rcvTarMax",
        "rcvAccMinSign+rcvAccMin",
        "rcvAccMaxSign+rcvAccMax",
        "sndCritical",
        "sndSetpoint",
        "sndTarMinSign+sndTarMin",
        "sndTarMaxSign+sndTarMax",
        "sndAcc1MinSign+sndAcc1Min",
        "sndAcc1MaxSign+sndAcc1Max",
        "reference",
    ],
    out: [
        "testItem",
/*        "samplePointNm",
        "dayCycle",*/
        "paraNm",
        "sopNo",
        "unit",
        "rcvCriticalNm+rcvCritical",
        "rcvSetpoint",
        "rcvTarMinSign+rcvTarMin",
        "rcvTarMaxSign+rcvTarMax",
        "rcvAccMinSign+rcvAccMin",
        "rcvAccMaxSign+rcvAccMax",
        "sndCritical",
        "sndSetpoint",
        "sndTarMinSign+sndTarMin",
        "sndTarMaxSign+sndTarMax",
        "sndAcc1MinSign+sndAcc1Min",
        "sndAcc1MaxSign+sndAcc1Max",
        "reference",
    ],
    qc: [
/*        "samplePointNm",
        "dayCycle",*/
        "sampleDesc",
        "paraNm",
        "testMethod",
        "unit",
        "rcvCriticalNm+rcvCritical",
        "rcvAlrMinSign+rcvAlrMin",
        "rcvAlrMaxSign+rcvAlrMax",
        "rcvActMinSign+rcvActMin",
        "rcvActMaxSign+rcvActMax",
        "rcvAccMinSign+rcvAccMin",
        "rcvAccMaxSign+rcvAccMax",
        "sndCritical",
        "sndAlrMinSign+sndAlrMin",
        "sndAlrMaxSign+sndAlrMax",
        "sndAct1MinSign+sndAct1Min",
        "sndAct1MaxSign+sndAct1Max",
        "sndAccMinSign+sndAccMin",
        "sndAccMaxSign+sndAccMax",
        "optionNm+optionCd",
        "reference",
    ],
};

const TABLE_BODY_INFO_PREVIEW = {
    composition: [
        "materialCd",
        "component",
        "mainAlter",
        "concentration",
        "unit1+unit2",
        "reference",
    ],
    in: [
        "paraDesc",
        "unit",
        "rcvCriticalNm",
        "rcvSetpoint",
        "rcvTarMinSign+rcvTarMin",
        "rcvTarMaxSign+rcvTarMax",
        "rcvAccMinSign+rcvAccMin",
        "rcvAccMaxSign+rcvAccMax",
        "sndCritical",
        "sndSetpoint",
        "sndTarMinSign+sndTarMin",
        "sndTarMaxSign+sndTarMax",
        "sndAcc1MinSign+sndAcc1Min",
        "sndAcc1MaxSign+sndAcc1Max",
        "reference",
    ],
    out: [
        "paraNm",
        "sopNo",
        "unit",
        "rcvCriticalNm",
        "rcvSetpoint",
        "rcvTarMinSign+rcvTarMin",
        "rcvTarMaxSign+rcvTarMax",
        "rcvAccMinSign+rcvAccMin",
        "rcvAccMaxSign+rcvAccMax",
        "sndCritical",
        "sndSetpoint",
        "sndTarMinSign+sndTarMin",
        "sndTarMaxSign+sndTarMax",
        "sndAcc1MinSign+sndAcc1Min",
        "sndAcc1MaxSign+sndAcc1Max",
        "reference",
    ],
    qc: [
        "sampleDesc",
        "paraNm",
        "testMethod",
        "unit",
        "rcvCriticalNm",
        "rcvAlrMinSign+rcvAlrMin",
        "rcvAlrMaxSign+rcvAlrMax",
        "rcvActMinSign+rcvActMin",
        "rcvActMaxSign+rcvActMax",
        "rcvAccMinSign+rcvAccMin",
        "rcvAccMaxSign+rcvAccMax",
        "sndCritical",
        "sndAlrMinSign+sndAlrMin",
        "sndAlrMaxSign+sndAlrMax",
        "sndAct1MinSign+sndAct1Min",
        "sndAct1MaxSign+sndAct1Max",
        "sndAccMinSign+sndAccMin",
        "sndAccMaxSign+sndAccMax",
        "optionNm+optionCd",
        "reference",
    ],
};

export { TABLE_BODY_INFO, TABLE_BODY_INFO2, TABLE_BODY_INFO_PREVIEW, TABLE_HEADER_INFO };
